module.exports = __webpack_public_path__ + "img/translator-RU.8a8ebc3.svg";